module.exports = __webpack_public_path__ + "img/FolderFile.d1a1ea44.svg";